exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kilometers[data-v-8cf6a67e] {\n  display: block;\n  height: 30px;\n  padding: 0;\n  line-height: 30px;\n}", ""]);

// exports
